// extracted by mini-css-extract-plugin
export default {"root":"ER15Jsbw","body":"qqwu6pJj","summary":"ZdGPRRwF","header":"O5rLuXjc","activity":"tefnSXGR"};